<div class="survey-container">
  <div class="survey-content">
    <div class="survey-header">
      <h1>Hebern Survey</h1>
      <p>
        Please help us understand your needs by answering the following
        questions.
      </p>
    </div>

    <div class="survey-form">
      @if (isInitialLoading) {
      <div class="loading-message">
        <span class="spinner"></span>
        Loading survey data...
      </div>
      } @else {
      <!-- Question 1: AI Coding -->
      <div class="question-group">
        <label class="question-label">
          Question 1: Have you ever used AI to code the majority of a program?
          (aka vibe coding)
        </label>
        <div class="radio-group">
          <label class="radio-option">
            <input
              type="radio"
              name="q1"
              value="true"
              [checked]="surveyData.q1 === true"
              (change)="onQuestionChange('q1', true)"
            />
            <span>Yes</span>
          </label>
          <label class="radio-option">
            <input
              type="radio"
              name="q1"
              value="false"
              [checked]="surveyData.q1 === false"
              (change)="onQuestionChange('q1', false)"
            />
            <span>No</span>
          </label>
        </div>
      </div>

      <!-- Question 2: User Sessions -->
      <div class="question-group">
        <label class="question-label">
          Question 2: How many user sessions does your platform receive per
          month?
        </label>
        <input
          type="text"
          class="number-input"
          placeholder="Enter number of sessions"
          [value]="formatNumberWithCommas(surveyData.q2)"
          (input)="onNumberInputChange('q2', $event)"
          (keydown)="onNumberInputKeyDown('q2', $event)"
          (blur)="onNumberInputBlur('q2', $event)"
          min="0"
        />
      </div>

      <!-- Question 3: Sensitive Data Storage -->
      <div class="question-group">
        <label class="question-label">
          Question 3: Do you store sensitive data like personally identifying
          user data or passwords?
        </label>
        <div class="radio-group">
          <label class="radio-option">
            <input
              type="radio"
              name="q3"
              value="true"
              [checked]="surveyData.q3 === true"
              (change)="onQuestionChange('q3', true)"
            />
            <span>Yes</span>
          </label>
          <label class="radio-option">
            <input
              type="radio"
              name="q3"
              value="false"
              [checked]="surveyData.q3 === false"
              (change)="onQuestionChange('q3', false)"
            />
            <span>No</span>
          </label>
        </div>
      </div>

      <!-- Question 4: Safe Storage Plan -->
      <div class="question-group">
        <label class="question-label">
          Question 4: Do you have a safe storage plan for sensitive data?
        </label>
        <div class="radio-group">
          <label class="radio-option">
            <input
              type="radio"
              name="q4"
              value="true"
              [checked]="surveyData.q4 === true"
              (change)="onQuestionChange('q4', true)"
            />
            <span>Yes</span>
          </label>
          <label class="radio-option">
            <input
              type="radio"
              name="q4"
              value="false"
              [checked]="surveyData.q4 === false"
              (change)="onQuestionChange('q4', false)"
            />
            <span>No</span>
          </label>
        </div>
      </div>

      <!-- Question 5: Monthly Payment -->
      <div class="question-group">
        <label class="question-label">
          Question 5: How much per month would you pay for automatic encryption
          of sensitive data?
        </label>
        <div class="currency-input-group">
          <span class="currency-symbol">$</span>
          <input
            type="text"
            class="currency-input"
            placeholder="0.00"
            [value]="formatCurrencyWithCommas(surveyData.q5)"
            (click)="onCurrencyClick($event)"
            (input)="onCurrencyInput($event)"
            (blur)="onCurrencyBlur($event)"
            min="0"
            step="0.01"
          />
        </div>
      </div>

      <!-- Question 6: Comments -->
      <div class="question-group">
        <label class="question-label">
          Question 6: Do you have any other questions or comments for us?
        </label>
        <textarea
          class="text-input"
          placeholder="Enter your comments or questions here..."
          [value]="surveyData.q6 || ''"
          (input)="onTextInputChange('q6', $event)"
          (blur)="onInputBlur('q6', $event)"
          rows="4"
        ></textarea>
      </div>

      <!-- Application Section (Visually separate from survey) -->
      <div class="application-section">
        <div class="application-card">
          <h2>Beta Tester Application</h2>
          <p class="application-subtitle">
            Would you like to apply to use this survey as an application to be a
            beta tester?
          </p>

          @if (applicationError) {
          <div class="application-error">{{ applicationError }}</div>
          } @if (isApplicationLoading) {
          <button class="application-button" disabled>
            <span class="button-spinner"></span>
            Processing...
          </button>
          } @else if (applicationApplied && applicationWithdrawn) {
          <div class="application-status withdrawn">Application withdrawn</div>
          } @else if (applicationApplied && !applicationWithdrawn) {
          <button
            class="application-button withdraw"
            (click)="confirmWithdraw()"
          >
            Withdraw application
          </button>
          } @else {
          <button class="application-button apply" (click)="applyForBeta()">
            Apply
          </button>
          }
        </div>
      </div>

      <!-- Withdraw Confirmation Modal (outside application card) -->
      @if (showWithdrawConfirmModal) {
      <div class="modal-backdrop" (click)="cancelWithdraw()"></div>
      <div class="modal">
        <div class="modal-header">Withdraw application?</div>
        <div class="modal-body">
          Are you sure you want to withdraw your application? You will not get
          another chance to apply.
        </div>
        <div class="modal-actions">
          <button class="modal-button secondary" (click)="cancelWithdraw()">
            No
          </button>
          <button class="modal-button danger" (click)="withdrawApplication()">
            Yes, withdraw
          </button>
        </div>
      </div>
      }

      <!-- Status Messages -->
      <div class="status-messages">
        @if (isLoading) {
        <div class="loading-message">
          <span class="spinner"></span>
          Updating survey...
        </div>
        } @else if (successMessage) {
        <div class="success-message">
          {{ successMessage }}
        </div>
        } @else if (errorMessage) {
        <div class="error-message">
          {{ errorMessage }}
        </div>
        } @else {
        <div class="info-message">
          Your answers will be recorded automatically
        </div>
        }
      </div>
      }
    </div>

    <!-- Toast Notification -->
    @if (showToast) {
    <div
      class="toast"
      [class.success]="toastType === 'success'"
      [class.error]="toastType === 'error'"
    >
      <div class="toast-content">
        <span class="toast-icon">
          @if (toastType === 'success') { ✓ } @else { ⚠ }
        </span>
        <span class="toast-message">{{ toastMessage }}</span>
        <button class="toast-close" (click)="hideToast()">×</button>
      </div>
    </div>
    }
  </div>
</div>
